import React, { useState } from 'react';
import { ImageDesktop, ImageDesktopBlue, ImageGamingJoy, ImageGamingRoom, ImageMobile, ImageProgramming, ImageWeb1, ImageWeb2, ImageWeb3, ImageWeb4 } from '../../../assets/images';
import { FeaturedCarousel } from '../../../components/Carousels';

const dummyData = [
  {image: ImageWeb1, link: '#' },
  {image: ImageWeb4, link: '#' },
  {image: ImageWeb3, link: '#' },
  {image: ImageWeb2, link: '#' },
]

function FeaturedHome() {

  const [data, setData] = useState(dummyData)

  return (
    <div id="FeaturedHome" className="offset">
      <div className="featured-home-description">
        <h1>Featured Project</h1>
      </div>
      <FeaturedCarousel item={data} />
    </div>
  )
}

export default FeaturedHome;
